import { createSelector } from '@reduxjs/toolkit';

const selectPDFExtraction = (state) => state.pdfExtraction;

export const selectPDFLoading = () => createSelector(selectPDFExtraction, (state) => state.loading);

export const selectPDFError = () => createSelector(selectPDFExtraction, (state) => state.error);
